import { useContext } from 'react';

import { SidebarContext, SidebarProps } from '../contexts/Sidebar.context';

export const useSidebar = (): SidebarProps => useContext(SidebarContext);
